/* PCB|Racks global behaviors: nav, cart AJAX + drawer, reveals, toasts. */
(function () {
  'use strict';

  /* Shopify's t-filter HTML-escapes locale strings (' -> &#39;). These strings are
 consumed via textContent in JS, so decode every i18n entry once at boot. */
  if (window.pcbr && window.pcbr.i18n) {
    var dec = document.createElement('textarea');
    Object.keys(window.pcbr.i18n).forEach(function (k) {
      var v = window.pcbr.i18n[k];
      if (typeof v === 'string' && v.indexOf('&') > -1) {
        dec.innerHTML = v;
        window.pcbr.i18n[k] = dec.value;
      }
    });
  }

  /* Locale-aware cart endpoints. Hardcoding '/cart.js' hits the ROOT locale, so
 on /es and /fr every AJAX cart action returned English product titles while
 the server-rendered cart page showed Spanish/French (audit catch).
 routes.cart_url is '/es/cart' on the Spanish storefront, so derive from it. */
  var CART_BASE = ((window.pcbr && window.pcbr.cartUrl) || '/cart');
  function cartJs() { return CART_BASE + '.js'; }
  function cartOp(op) { return CART_BASE + '/' + op + '.js'; }

  var money = function (cents) {
    var fmt = (window.pcbr && window.pcbr.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------- Toasts ---------- */
  function toast(message, type, linkHtml) {
    var region = document.getElementById('toast-region');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast toast--' + (type || 'success');
    el.innerHTML = '<span>' + message + '</span>' + (linkHtml || '');
    region.appendChild(el);
    setTimeout(function () {
      el.style.opacity = '0';
      el.style.transition = 'opacity 0.3s';
      setTimeout(function () { el.remove(); }, 320);
    }, 3200);
  }

  /* ---------- Deep-link re-aim ----------
 Arriving on #type-slot / #compare / #specs, the browser jumps to where the
 target sat before the images above it loaded, so it lands short of the
 heading and the section looks like it was never reached. Re-aim once the
 page has settled — unless the visitor already took over by scrolling. */
  (function () {
    if (!location.hash || location.hash.length < 2) return;
    var hash = location.hash, taken = false;
    function userTook() { taken = true; }
    window.addEventListener('wheel', userTook, { passive: true, once: true });
    window.addEventListener('touchstart', userTook, { passive: true, once: true });
    window.addEventListener('keydown', userTook, { once: true });
    window.addEventListener('load', function () {
      setTimeout(function () {
        if (taken) return;
        var el;
        try { el = document.querySelector(hash); } catch (e) { return; }   /* not a valid selector */
        if (el) el.scrollIntoView({ block: 'start', behavior: 'auto' });
      }, 90);
    });
  })();

  /* ---------- Scroll reveals ---------- */
  var revealTargets = document.querySelectorAll('.reveal, .reveal-stagger');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px 120px 0px', threshold: 0.01 });
    revealTargets.forEach(function (t) { io.observe(t); });
  } else {
    revealTargets.forEach(function (t) { t.classList.add('is-visible'); });
  }

  /* ---------- Lazy videos ---------- */
  var lazyVids = document.querySelectorAll('video[data-lazy]');
  if ('IntersectionObserver' in window && lazyVids.length) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target;
        v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
        v.load();
        v.play().catch(function () {});
        vio.unobserve(v);
      });
    }, { rootMargin: '200px' });
    lazyVids.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- Mega menu (desktop hover + keyboard) ---------- */
  document.querySelectorAll('[data-mega-item]').forEach(function (li) {
    var closeTimer;
    li.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      closeSiblings(li);
      li.classList.add('is-open');
    });
    li.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () { li.classList.remove('is-open'); }, 120);
    });
    li.addEventListener('focusin', function () { closeSiblings(li); li.classList.add('is-open'); });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) li.classList.remove('is-open');
    });
    /* Same-page anchor targets (#type-slot, #series-gear) scroll without a
 reload, so the panel would stay open over the section the visitor just
 asked to see — it reads as a dead click. Close it on any link click. */
    li.addEventListener('click', function (e) {
      if (e.target.closest('a')) li.classList.remove('is-open');
    });
  });
  function closeSiblings(li) {
    var root = li.closest('[data-mega-root]');
    if (root) root.querySelectorAll('.is-open').forEach(function (o) { if (o !== li) o.classList.remove('is-open'); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mega-item].is-open').forEach(function (o) { o.classList.remove('is-open'); });
      closeDrawer(); closeCart();
    }
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 300);
  }
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  /* Cart page renders its lines server-side; fetch once on load so the upsell
 zone fills without waiting for a cart change. */
  if (document.querySelector('.cart-page [data-cart-upsell]')) {
    fetch(cartJs()).then(function (r) { return r.json(); }).then(renderUpsell).catch(function () {});
  }
  function openCart() {
    if (!cartDrawer) return;
    refreshCart();
    cartDrawer.hidden = false;
    requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { cartDrawer.hidden = true; }, 300);
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
    document.querySelectorAll('[data-cart-count-inline]').forEach(function (el) { el.textContent = count; });
  }

  var SVG_MINUS = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M4 12h16"/></svg>';
  var SVG_PLUS = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 4v16M4 12h16"/></svg>';
  var SVG_TRASH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6.5 7l1 13h9l1-13"/></svg>';

  /* Cart upsell: gear-adjust racks pull the chassis-matched wear kit, screw/belt/HT
 racks pull the spares collection, depaneling blades pull their starter kit.
 Config (variant ids, prices, maps) is emitted by theme.liquid so it always
 tracks live products. Cards hide once the suggested item is already in cart. */
  function renderUpsell(cart) {
    var zones = document.querySelectorAll('[data-cart-upsell]');
    if (!zones.length) return;
    var U = (window.pcbr && window.pcbr.upsell) || null;
    var T = (window.pcbr && window.pcbr.i18n) || {};
    if (!U || !cart.items.length) { zones.forEach(function (z) { z.hidden = true; z.innerHTML = ''; }); return; }
    var handles = cart.items.map(function (i) { return i.handle; });
    var cards = [];
    var hasWearKit = handles.indexOf(U.wearKitHandle) !== -1;
    var chassisKey = null;
    handles.forEach(function (h) { if (!chassisKey && U.rackMap[h]) chassisKey = U.rackMap[h]; });
    if (chassisKey && !hasWearKit && U.wearVariants[chassisKey]) {
      var wv = U.wearVariants[chassisKey];
      cards.push('<div class="cart-upsell"><p class="cu-title">' + (T.upsellWearTitle || '').replace('[[chassis]]', wv.chassis) + '</p>' +
        '<p class="cu-body">' + (T.upsellWearBody || '') + '</p>' +
        '<p class="cu-cta"><button type="button" class="btn btn--primary" data-upsell-add="' + wv.id + '">' +
        (T.upsellAdd || 'Add').replace('[[price]]', money(wv.price)) + '</button></p></div>');
    } else if (!chassisKey && U.screwRacks && handles.some(function (h) { return U.screwRacks.indexOf(h) !== -1; })) {
      /* Screw adjustment wears at the side panels and the frame, not the gear
 train, so name those two kits instead of pointing at the whole spares
 shelf. Links rather than adds: both are chassis and temperature
 specific, and guessing the variant ships the wrong part. */
      var parts = (U.screwParts || []).filter(function (p) { return handles.indexOf(p.url.split('/').pop()) === -1; });
      if (parts.length) {
        cards.push('<div class="cart-upsell"><p class="cu-title">' + (T.upsellScrewTitle || '') + '</p>' +
          '<p class="cu-body">' + (T.upsellScrewBody || '') + '</p>' +
          '<p class="cu-cta">' + parts.map(function (p) {
            return '<a class="btn btn--ghost" href="' + p.url + '">' + p.title.split('·')[0].trim() +
              ' · ' + (T.upsellFrom || 'from') + ' ' + money(p.from) + '</a>';
          }).join(' ') + '</p></div>');
      }
    } else if (!chassisKey && !hasWearKit && handles.some(function (h) { return U.otherRacks.indexOf(h) !== -1; })) {
      cards.push('<div class="cart-upsell"><p class="cu-title">' + (T.upsellSparesTitle || '') + '</p>' +
        '<p class="cu-body">' + (T.upsellSparesBody || '') + '</p>' +
        '<p class="cu-cta"><a class="btn btn--ghost" href="' + U.sparesUrl + '">' + (T.upsellView || '') + '</a></p></div>');
    }
    /* Universal-rack family. A turntable and the bench racks are two halves of one
 workstation, so whichever half is in the cart offers the other. Links rather
 than adds: the bench racks are packs of 10 in four board sizes and picking a
 size for the buyer ships the wrong pack. */
    var hasTurn = (U.benchTurntables || []).some(function (h) { return handles.indexOf(h) !== -1; });
    var hasBench = (U.benchRacks || []).some(function (h) { return handles.indexOf(h) !== -1; });
    function linkCard(title, body, parts, fallbackUrl) {
      var live = (parts || []).filter(function (p) { return handles.indexOf(p.url.split('/').pop()) === -1; });
      var cta = live.length
        ? live.map(function (p) {
            return '<a class="btn btn--ghost" href="' + p.url + '">' + p.title.split('·')[0].trim() +
              ' · ' + (T.upsellFrom || 'from') + ' ' + money(p.from) + '</a>';
          }).join(' ')
        : '<a class="btn btn--ghost" href="' + fallbackUrl + '">' + (T.upsellView || '') + '</a>';
      return '<div class="cart-upsell"><p class="cu-title">' + title + '</p>' +
        '<p class="cu-body">' + body + '</p><p class="cu-cta">' + cta + '</p></div>';
    }
    if (hasTurn && !hasBench) {
      cards.push(linkCard(T.upsellBenchTitle || '', T.upsellBenchBody || '', U.benchRackParts, U.benchUrl));
    } else if (hasBench && !hasTurn) {
      cards.push(linkCard(T.upsellTurnTitle || '', T.upsellTurnBody || '', U.benchTurnParts, U.benchUrl));
    }

    var kitHandle = null;
    handles.forEach(function (h) { if (!kitHandle && U.bladeMap[h]) kitHandle = U.bladeMap[h]; });
    if (kitHandle && handles.indexOf(kitHandle) === -1) {
      cards.push('<div class="cart-upsell"><p class="cu-title">' + (T.upsellKitTitle || '') + '</p>' +
        '<p class="cu-body">' + (T.upsellKitBody || '') + '</p>' +
        '<p class="cu-cta"><a class="btn btn--ghost" href="' + (U.kitUrls[kitHandle] || '#') + '">' + (T.upsellKitCta || '') + '</a></p></div>');
    }
    zones.forEach(function (z) {
      z.hidden = !cards.length;
      z.innerHTML = cards.length ? '<p class="cart-upsell-head">' + (T.upsellHeading || '') + '</p>' + cards.join('') : '';
    });
  }

  /* The wear kit add-on has one door: the offer shown after a rack order is paid. It is
 never sold through the cart, so a line that arrives here by variant id comes back out
 and the buyer is pointed at the kit that is sold on its own. */
  var ADDON_HANDLE = 'rack-wear-kit-addon';
  var addonFixing = false;
  function dropStrayAddon(cart, done) {
    var strays = (cart.items || []).filter(function (it) { return it.handle === ADDON_HANDLE; });
    if (!strays.length || addonFixing) return false;
    addonFixing = true;
    var upd = {};
    strays.forEach(function (it) { upd[it.key] = 0; });
    fetch(cartOp('update'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: upd })
    }).then(function (r) { return r.json(); }).then(function (c) {
      addonFixing = false;
      var i18n = (window.pcbr && window.pcbr.i18n) || {};
      toast(i18n.addonOnly || 'That add-on price comes with a rack order. The Rack Wear Kit is sold on its own.', 'error', ' <a href="/products/rack-wear-kit">Rack Wear Kit</a>');
      if (done) done(c);
    }).catch(function () { addonFixing = false; });
    return true;
  }

  function renderCart(cart) {
    if (dropStrayAddon(cart, function (c) {
      /* the cart page draws its lines on the server, so it has to load again */
      if (document.querySelector('[data-cart-page]') || /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      else renderCart(c);
    })) return;
    updateCounts(cart.item_count);
    renderUpsell(cart);
    /* Empty cart: the drawer foot (subtotal, PO, checkout, notes) is commerce
 chrome with nothing to act on, and on a phone it ate most of the panel
 while the family tiles got a sliver. Hide it entirely and
 give the empty state the room. */
    document.querySelectorAll('[data-cart-foot]').forEach(function (f) {
      f.hidden = cart.item_count === 0;
    });
    var subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    var fsI18n = (window.pcbr && window.pcbr.i18n) || {};
    /* Free shipping meter (Oct 12 2026): US orders of $1,000 and up ship free, by an
 automatic discount at checkout. Under that, the line shows how far the cart is. */
    var shipMin = (window.pcbr && typeof window.pcbr.freeShipMin === 'number') ? window.pcbr.freeShipMin : 100000;
    document.querySelectorAll('[data-cart-total]').forEach(function (t) { t.setAttribute('data-cart-total', String(cart.total_price)); });
    document.querySelectorAll('[data-collect-row]').forEach(function (r) { r.hidden = cart.item_count === 0 || cart.total_price >= shipMin; });
    document.querySelectorAll('[data-ship-meter]').forEach(function (m) {
      m.hidden = cart.item_count === 0;
      if (cart.total_price >= shipMin) {
        m.textContent = fsI18n.shipFree || 'This order ships free in the US.';
        m.classList.add('is-free');
      } else {
        m.textContent = (fsI18n.shipGap || 'Add [[amount]] more and US shipping is free.').replace('[[amount]]', money(shipMin - cart.total_price));
        m.classList.remove('is-free');
      }
    });
    /* Order minimum. There is none while orderMin is 0 in the layout; give it a
 value there and the warning and the held checkout button come back. Read it as a
 number on purpose: a plain || fallback would turn 0 back into a minimum. */
    var minOrder = (window.pcbr && typeof window.pcbr.orderMin === 'number') ? window.pcbr.orderMin : 0;
    var underMin = cart.item_count > 0 && cart.total_price < minOrder;
    var minWarn = document.querySelector('[data-min-warn]');
    if (minWarn) {
      minWarn.hidden = !underMin;
      if (underMin) minWarn.textContent = (fsI18n.minWarning || '').replace('[[amount]]', money(minOrder - cart.total_price));
    }
    document.querySelectorAll('[data-checkout-btn]').forEach(function (b) {
      b.classList.toggle('is-disabled', underMin);
      if (underMin) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('tabindex', '-1'); b.style.pointerEvents = 'none'; b.style.opacity = '0.45'; }
      else { b.removeAttribute('aria-disabled'); b.removeAttribute('tabindex'); b.style.pointerEvents = ''; b.style.opacity = ''; }
    });
    var wrap = document.querySelector('[data-cart-lines]');
    if (!wrap) return;
    if (!cart.items.length) {
      /* An empty cart used to be a dead end with one vague "Browse products" link.
 Same six family tiles the server renders (snippets/cart-empty-tiles.liquid);
 config comes from theme.liquid so the copy stays translated. */
      var fam = (window.pcbr && window.pcbr.emptyFamilies) || [];
      var tiles = fam.map(function (f) {
        return '<a class="cart-fam-tile" href="' + f.url + '">' +
          '<img src="' + f.img + '" alt="" width="72" height="72" loading="lazy">' +
          '<span>' + f.label + '</span></a>';
      }).join('');
      wrap.innerHTML = '<div class="cart-empty"><p><strong>' + (fsI18n.emptyTitle || 'Your cart is empty.') + '</strong></p>' +
        '<p>' + (fsI18n.emptyNote || '') + '</p></div>' +
        (tiles ? '<div class="cart-fam"><p class="cart-fam-lead">' + (fsI18n.emptyLead || '') + '</p>' +
          '<div class="cart-fam-grid">' + tiles + '</div></div>'
         : '<div class="cart-empty"><a class="btn btn--primary" href="/collections/all">' + (fsI18n.browse || 'Browse products') + '</a></div>');
      return;
    }
    /* Pack lines quote per unit under the line total, matching the server-rendered
 drawer. final_price is the price of ONE pack after line discounts, so the
 per-unit figure tracks any volume discount already applied. */
    function unitLine(item) {
      var sizes = (window.pcbr && window.pcbr.packSizes) || {};
      var n = sizes[item.handle];
      if (!n || n < 2) return '';
      return '<div class="cart-line-unit">' + money(Math.round(item.final_price / n)) +
        ' ' + ((window.pcbr && window.pcbr.perUnit) || 'per unit') + '</div>';
    }

    wrap.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_144x$1$2') : '';
      return '<div class="cart-line" data-line="' + (i + 1) + '" data-key="' + item.key + '">' +
        (img ? '<img src="' + img + '" alt="" width="72" height="72">' : '<div class="skeleton" style="width:72px;height:72px;border-radius:4px;"></div>') +
        '<div><p class="cart-line-title">' + item.product_title + '</p>' +
        '<span class="cart-line-sku">' + (item.sku || '') + '</span>' +
        '<div class="qty-stepper">' +
        '<button data-qty-minus aria-label="' + (fsI18n.qtyDown || 'Decrease quantity') + '">' + SVG_MINUS + '</button>' +
        '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="' + (fsI18n.qty || 'Quantity') + '">' +
        '<button data-qty-plus aria-label="' + (fsI18n.qtyUp || 'Increase quantity') + '">' + SVG_PLUS + '</button></div></div>' +
        '<div><div class="cart-line-price">' + money(item.final_line_price) + '</div>' + unitLine(item) +
        '<button class="cart-line-remove" data-line-remove aria-label="' + (fsI18n.removeItem || 'Remove') + ' ' + (item.product_title || '').replace(/"/g, '') + '">' + SVG_TRASH + '</button></div></div>';
    }).join('');
  }

  function refreshCart() {
    fetch(cartJs()).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  /* The layout says when the cart it rendered holds the add-on, so the check above runs on
 arrival and not only when the drawer opens. */
  if (window.pcbr && window.pcbr.strayAddon) refreshCart();

  function changeLine(line, quantity) {
    fetch(cartOp('change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      // The cart page renders lines + the order-minimum warning server-side;
      // reload so they stay in sync with the new quantities.
      if (document.querySelector('.cart-page')) { location.reload(); return; }
      renderCart(cart);
    }).catch(function () {
      toast((window.pcbr.i18n || {}).cartFail || 'Could not update the cart. Try again.', 'error');
    });
  }

  /* Upsell add: one-click add of the suggested wear kit variant, then re-render.
 The cart page reloads (its lines are server-rendered), the drawer re-renders. */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-upsell-add]');
    if (!up) return;
    up.disabled = true;
    fetch(cartOp('add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(up.dataset.upsellAdd, 10), quantity: 1 })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function () {
      toast((window.pcbr.i18n || {}).addedToast || 'Added to cart.', 'success');
      if (document.querySelector('.cart-page')) { location.reload(); return; }
      refreshCart();
    }).catch(function () {
      up.disabled = false;
      toast((window.pcbr.i18n || {}).addFail || 'Could not add to cart. Try again.', 'error');
    });
  });

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-line-remove]');
    if (!minus && !plus && !remove) return;
    var lineEl = e.target.closest('.cart-line');
    if (!lineEl) return;
    var line = parseInt(lineEl.dataset.line, 10);
    var input = lineEl.querySelector('[data-qty-input]');
    var qty = parseInt(input && input.value || '1', 10);
    if (minus) changeLine(line, Math.max(0, qty - 1));
    if (plus) changeLine(line, qty + 1);
    if (remove) changeLine(line, 0);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var lineEl = e.target.closest('.cart-line');
    if (!lineEl) return;
    changeLine(parseInt(lineEl.dataset.line, 10), Math.max(0, parseInt(e.target.value || '0', 10)));
  });

  /* ---------- Add to cart ---------- */
  function pcbrLineProps() {
    var els = document.querySelectorAll('[data-line-prop]');
    if (!els.length) return null;
    var props = {};
    var any = false;
    els.forEach(function (el) {
      if (el.value.trim()) { props[el.dataset.propName || 'Info'] = el.value.trim(); any = true; }
    });
    if (any) return props;
    var first = els[0].dataset.propName || 'Info';
    var ack = document.querySelector('[data-serial-ack]');
    if (ack) {
      props[first] = ack.checked
        ? 'To follow by email, buyer acknowledged (ships on receipt; ship date confirmed within one business day)'
        : 'Not provided at purchase, follow-up required before shipping';
    } else {
      props[first] = 'Not provided at purchase, confirm at fulfillment';
    }
    return props;
  }
  function pcbrSerialGate() {
    /* Never blocks the sale — courtesy reminder only on serial-acknowledgment products */
    var ack = document.querySelector('[data-serial-ack]');
    if (!ack) return true;
    var el = document.querySelector('[data-line-prop]');
    if (el && !el.value.trim() && !ack.checked) {
      toast((window.pcbr.i18n || {}).serialGate || 'You can order now, email your serial to info@pcbracks.com after purchase. We ship once it arrives.', 'success');
    }
    return true;
  }

  /* PO number → cart attribute (Marisol fix #1) */
  document.addEventListener('change', function (e) {
    var po = e.target.closest('[data-po-input]');
    if (!po) return;
    fetch(cartOp('update'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'PO number': po.value.trim() } })
    }).then(function () {
      document.querySelectorAll('[data-po-input]').forEach(function (x) { if (x !== po) x.value = po.value; });
    }).catch(function () {});
  });

  /* Freight collect (Oct 12 2026): under $1,000 the buyer can tick "ship on my own UPS or
 FedEx account". Nobody types an account number on the site (the owner: a buyer would not);
 the order carries a "Freight collect" attribute, the owner asks for the number by email
 before shipping, and the checkout goes through the FREIGHTCOLLECT code so no freight is
 charged. At $1,000 and up the automatic free shipping already applies. */
  document.addEventListener('change', function (e) {
    var ca = e.target.closest('[data-collect-input]');
    if (!ca) return;
    var val = ca.checked ? 'Yes. Ask me for my UPS or FedEx account number before shipping.' : '';
    fetch(cartOp('update'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Freight collect': val } })
    }).then(function () {
      document.querySelectorAll('[data-collect-input]').forEach(function (x) { if (x !== ca) x.checked = ca.checked; });
    }).catch(function () {});
  });
  function pcbrCollectCheckout() {
    var ca = document.querySelector('[data-collect-input]');
    if (!ca || !ca.checked) return false;
    var tot = document.querySelector('[data-cart-total]');
    var total = tot ? parseInt(tot.getAttribute('data-cart-total'), 10) : 0;
    var shipMin = (window.pcbr && typeof window.pcbr.freeShipMin === 'number') ? window.pcbr.freeShipMin : 100000;
    return total > 0 && total < shipMin;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-checkout-btn]');
    if (!b || b.getAttribute('aria-disabled') === 'true' || !pcbrCollectCheckout()) return;
    e.preventDefault();
    window.location.href = '/discount/FREIGHTCOLLECT?redirect=%2Fcheckout';
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var sub = e.submitter;
    if (!f || !f.matches || !f.matches('form[action$="/cart"]') || !sub || sub.name !== 'checkout') return;
    if (!pcbrCollectCheckout()) return;
    e.preventDefault();
    window.location.href = '/discount/FREIGHTCOLLECT?redirect=%2Fcheckout';
  });

  /* Subscribe and save: which purchase option the buyer picked. The native form
 posts this by itself, so this only exists to keep the AJAX path in sync with
 the no-JS path. Empty string means one-time, which is Shopify's own convention. */
  function pcbrSellingPlan() {
    var picked = document.querySelector('input[name="selling_plan"]:checked');
    if (!picked || !picked.value) return null;
    return parseInt(picked.value, 10) || null;
  }

  /* The buy box is a real POST form so it still works with JS dead. When JS is
 alive we own the submit (including Enter pressed in the quantity field) and
 run the AJAX drawer instead of a full page reload. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-buy-form]');
    if (!form) return;
    e.preventDefault();
    var trigger = form.querySelector('[data-add-to-cart]');
    if (trigger) trigger.click();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    if (!pcbrSerialGate()) return;
    var variantId = btn.dataset.variantId;
    var qtyInput = document.querySelector('[data-product-qty]');
    var qty = btn.dataset.quantity || (qtyInput ? qtyInput.value : 1);
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = (window.pcbr.i18n || {}).adding || 'Adding…';
    fetch(cartOp('add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign(
        { id: parseInt(variantId, 10), quantity: parseInt(qty, 10) || 1 },
        pcbrLineProps() ? { properties: pcbrLineProps() } : {},
        pcbrSellingPlan() ? { selling_plan: pcbrSellingPlan() } : {}
      ))
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.textContent = (window.pcbr.i18n || {}).added || 'Added ✓';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
      toast((window.pcbr.i18n || {}).addedToast || 'Added to cart.', 'success');
      openCart();
    }).catch(function () {
      btn.textContent = label;
      btn.disabled = false;
      toast((window.pcbr.i18n || {}).addFail || 'Could not add to cart. Try again.', 'error');
    });
  });

  /* ---------- Buy now (add + straight to checkout) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    if (!pcbrSerialGate()) return;
    var qtyInput = document.querySelector('[data-product-qty]');
    fetch(cartOp('add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign(
        { id: parseInt(btn.dataset.variantId, 10), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 },
        pcbrLineProps() ? { properties: pcbrLineProps() } : {},
        pcbrSellingPlan() ? { selling_plan: pcbrSellingPlan() } : {}
      ))
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch(cartJs()).then(function (c) { return c.json(); });
    }).then(function (cart) {
      /* Any order minimum holds on EVERY path to checkout. Under it, Buy now lands
 in the drawer where the shortfall warning and held button explain why. */
      var minOrder = (window.pcbr && typeof window.pcbr.orderMin === 'number') ? window.pcbr.orderMin : 0;
      if (cart.item_count > 0 && cart.total_price < minOrder) { refreshCart(); openCart(); return; }
      window.location.href = '/checkout';
    }).catch(function () {
      toast((window.pcbr.i18n || {}).checkoutFail || 'Could not start checkout. Try again.', 'error');
    });
  });

  /* ---------- Count-up numbers (ROI calculator + stats) ---------- */
  window.pcbrCountUp = function (el, target, opts) {
    opts = opts || {};
    var dur = opts.duration || 600;
    var prefix = opts.prefix || '';
    var suffix = opts.suffix || '';
    var decimals = opts.decimals || 0;
    var start = parseFloat((el.dataset.current || '0')) || 0;
    var t0 = null;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = prefix + target.toLocaleString(undefined, { maximumFractionDigits: decimals }) + suffix;
      el.dataset.current = target;
      return;
    }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = start + (target - start) * eased;
      el.textContent = prefix + val.toLocaleString(undefined, { maximumFractionDigits: decimals, minimumFractionDigits: decimals }) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.dataset.current = target;
    }
    requestAnimationFrame(step);
  };

  /* ---------- Inline form validation ---------- */
  /* Order minimum, enforced structurally: ANY link or form that heads to
 checkout is caught here, not just the two buttons that exist today. A future
 section can add its own checkout button and it inherits the rule for free.
 (The authoritative block is a Shopify cart-validation Function; until that is
 deployed this covers every door the storefront renders.) */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('a[href*="/checkout"], button[name="checkout"], [data-checkout-btn]');
    if (!el || el.dataset.minChecked === '1') return;
    /* No minimum set: let the click through untouched, with no cart round trip
 standing between the buyer and checkout. */
    if (!((window.pcbr && typeof window.pcbr.orderMin === 'number') ? window.pcbr.orderMin : 0)) return;
    e.preventDefault();
    fetch(cartJs()).then(function (r) { return r.json(); }).then(function (cart) {
      var minOrder = (window.pcbr && typeof window.pcbr.orderMin === 'number') ? window.pcbr.orderMin : 0;
      if (cart.item_count > 0 && cart.total_price < minOrder) {
        var i18n = (window.pcbr && window.pcbr.i18n) || {};
        toast((i18n.minWarning || 'Order minimum not met.').replace('[[amount]]', money(minOrder - cart.total_price)), 'error');
        refreshCart();
        openCart();
        return;
      }
      /* cleared: replay the original click so the native navigation runs */
      el.dataset.minChecked = '1';
      el.click();
      delete el.dataset.minChecked;
    });
  }, true);

  /* Shopify spam protection: with hCaptcha ON in Preferences the server rejects
 any /contact POST that has no token, and on a custom theme nothing binds the
 invisible widget, so Send silently did nothing (Round 258 audit catch).
 Shopify.captcha.protect is Shopify's own hook for exactly this: it arms the
 form so submit runs the invisible check and then posts natively. The captcha
 bundle loads async, so retry briefly until it appears. */
  (function armCaptcha(tries) {
    if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
      document.querySelectorAll('form[action*="/contact"]').forEach(function (f) {
        if (f.__captchaArmed) return;
        f.__captchaArmed = true;
        try { Shopify.captcha.protect(f, function () {}); } catch (e) {}
      });
      return;
    }
    if (tries > 0) setTimeout(function () { armCaptcha(tries - 1); }, 500);
  })(20);

  document.querySelectorAll('form[data-validate]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var ok = true;
      form.querySelectorAll('[required]').forEach(function (input) {
        var field = input.closest('.field');
        var valid = input.checkValidity();
        if (field) field.classList.toggle('has-error', !valid);
        if (!valid) ok = false;
      });
      if (!ok) {
        e.preventDefault();
        var first = form.querySelector('.has-error input, .has-error select, .has-error textarea');
        if (first) first.focus();
      }
    });
    form.addEventListener('input', function (e) {
      var field = e.target.closest('.field.has-error');
      if (field && e.target.checkValidity()) field.classList.remove('has-error');
    });
  });

  /* ---------- Card carousels ----------
 Every [data-fp-carousel] becomes a snapping card row: swipe/wheel at your
 own speed, arrows and Left/Right advance exactly ONE card. One shared
 implementation for home best-sellers, the collection group rows and the
 product-page recommendation rows.
 Hard-won constraints (see round 63): the glide is rAF over scrollLeft
 because native behavior:'smooth' stalls or gets cut short by mandatory
 snap; snap is suspended during the glide and always restored; arrow state
 only updates once scrolling settles (mid-flight DOM writes abort the
 animation); hidden tab / reduced motion jump instantly. */
  var fpReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-fp-carousel]').forEach(function (wrap) {
    if (wrap.dataset.fpInit) return;
    wrap.dataset.fpInit = '1';
    var track = wrap.querySelector('[data-fp-track]');
    var prev = wrap.querySelector('[data-fp-prev]');
    var next = wrap.querySelector('[data-fp-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.pcard');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }
    function refreshArrows() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= max - 4;
      if (prev && prev.disabled !== atStart) prev.disabled = atStart;
      if (next && next.disabled !== atEnd) next.disabled = atEnd;
    }
    function refreshNav() {
      var has = (track.scrollWidth - track.clientWidth) > 4;
      if (wrap.classList.contains('fp-has-nav') !== has) wrap.classList.toggle('fp-has-nav', has);
      /* Rows that fit are centred, not left-parked; under 3 tiles the
 spotlight dim stays off. */
      wrap.classList.toggle('fp-centered', !has);
      wrap.classList.toggle('fp-few', track.querySelectorAll('.pcard').length < 3);
      refreshArrows();
    }
    var anim, snapSafety, DUR = 380;
    function settleAt(target) {
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      track.scrollLeft = target;
      track.style.scrollSnapType = '';
      refreshArrows();
    }
    function animateTo(target) {
      if (anim) cancelAnimationFrame(anim);
      clearTimeout(snapSafety);
      var start = track.scrollLeft, delta = target - start;
      if (Math.abs(delta) < 1) return;
      if (fpReduce || document.hidden) { settleAt(target); return; }
      track.style.scrollSnapType = 'none';
      var t0 = null;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = start + delta * e;
        if (p < 1) { anim = requestAnimationFrame(frame); }
        else { anim = null; track.style.scrollSnapType = ''; refreshArrows(); }
      }
      anim = requestAnimationFrame(frame);
      snapSafety = setTimeout(function () { settleAt(target); }, DUR + 400);
    }
    function go(dir) {
      var s = step();
      if (!s) return;
      var max = Math.max(0, Math.ceil((track.scrollWidth - track.clientWidth) / s));
      var idx = Math.min(max, Math.max(0, Math.round(track.scrollLeft / s) + dir));
      animateTo(Math.min(idx * s, track.scrollWidth - track.clientWidth));
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(refreshArrows, 150);
    }, { passive: true });
    window.addEventListener('resize', refreshNav);
    if (window.ResizeObserver) new ResizeObserver(refreshNav).observe(track);
    refreshNav();
  });
})();

/* Guru chips: any [data-guru-chip] opens the site-wide guru takeover instead
 of navigating; the href (/#qa) stays as the no-JS fallback. */
(function () {
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-guru-chip]');
    if (!chip) return;
    var btn = document.querySelector('[data-guru-open]');
    if (btn) { e.preventDefault(); btn.click(); }
  });
})();

/* --- Fleet door: any [data-fleet-sam] element opens Sam seeded with
 the fleet intent, so a line buyer lands in a guided order build instead of
 an empty chat. Falls through to the element's own href (the contact form's
 fleet topic) when the chat isn't on the page. --- */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-fleet-sam]');
  if (!b || !window.pcbrGuru) return;
  e.preventDefault();
  window.pcbrGuru.open(b.getAttribute('data-seed'));
});

/* --- Lazy video (page-weight ticket, Oct 18 2026). The 360° clips used to
 autoplay with a src on the tag, so every visit fetched megabytes of video
 before the page was readable. Now the tag carries data-lazy-src and
 preload="none"; the src is attached and playback starts only when the video
 scrolls near the viewport. Same clip, same look, nothing downloaded unseen. --- */
(function () {
  var vids = document.querySelectorAll('video[data-lazy-src]');
  if (!vids.length) return;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function start(v) {
    if (v.getAttribute('src')) return;
    v.src = v.getAttribute('data-lazy-src');
    v.load();
    if (still) return; /* reduced motion: the clip is ready behind its poster, the viewer starts it */
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { start(en.target); io.unobserve(en.target); } });
  }, { rootMargin: '200px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();
